import React from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Member, MemberText, MemberAmount } from './member-order-request.styles';
import { Photo } from '@shared/ui/photo/photo';
import { MemberOrderRequestProps } from './types';

export const MemberOrderRequest: React.FC<MemberOrderRequestProps> = ({
    photoUrl,
    nameShort,
    nameFull,
    jobTitle,
    quantity,
}) => {
    return (
        <Member>
            <Photo photoUrl={photoUrl} size='l' name={nameShort} />
            <MemberText>
                <Typography color='neutral_50' size='body1_short'>
                    {nameFull || 'Профиль удален'}
                </Typography>

                {jobTitle && (
                    <Typography color='neutral_90' size='body1_long'>
                        {jobTitle}
                    </Typography>
                )}
            </MemberText>

            <MemberAmount>
                <Typography color='neutral_50' size='body1_long' as='p'>
                    Количество
                    <Typography color='neutral_90' size='h6' as='span'>
                        {quantity}
                    </Typography>
                </Typography>
            </MemberAmount>
        </Member>
    );
};
